import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { Button } from "@mui/material";

const ButtonLoading = (props) => {
  const { loading, disabled, children, ...rest } = props;
  return (
    <Button
      {...rest}
      disabled={Boolean(loading) || Boolean(disabled)}
    >
      {loading ? (
        <CircularProgress thickness={5} size="1.655rem" />
      ) : (
        children
      )}
    </Button>
  );
};

export default ButtonLoading;
